var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.1,46.3h36v30.9h23.1V48.4l10.9,10.9c0.9,0.9,2.2,1.5,3.6,1.5h20.6c2.8,0,5.1-2.3,5.1-5.1c0-2.8-2.3-5.1-5.1-5.1H99 L86,37.5c-1-1-2.3-1.5-3.6-1.5H23.1c-2.8,0-5.1,2.3-5.1,5.1C18,44,20.3,46.3,23.1,46.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.3,
    cy: 23.1,
    r: 9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.2,111.9c10.3,4.3,19.6,10.4,27.4,18.3l13.8,13.8h3.8l-15.7-15.7c-5.7-5.7-12-10.5-19-14.4 c16.2-10.7,29.6-25.2,39.8-43l1.2-2h-2.3c-0.1,0-0.2,0-0.3,0c-20.8,0-40.1,4.5-57.6,13.4H43.7c-2.8,0-5.1,2.3-5.1,5.1v15.3H0v2.7 h50.8C62,105.5,72.9,107.6,83.2,111.9z M48.9,92.6h8.7c-3,2.2-5.9,4.5-8.7,6.9V92.6z M69.8,87.8c18-10.4,38.2-15.9,60.1-16.2 c-10.1,16.9-23.2,30.7-39,40.8c-2.2-1.1-4.4-2.1-6.6-3.1c-10.6-4.4-21.9-6.7-33.4-6.7h-1.5C55.6,97.1,62.4,92.1,69.8,87.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.1,122.2c10.3,4.3,19.6,10.4,27.4,18.3l3.5,3.5h3.8l-5.4-5.4c-8.2-8.2-17.7-14.5-28.3-19c-10.6-4.4-21.9-6.7-33.4-6.7 H0v2.7h45.7C56.9,115.8,67.8,117.9,78.1,122.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67,142.8c1,0.4,1.9,0.8,2.8,1.2H76c-2.6-1.4-5.2-2.6-7.9-3.7c-10.6-4.4-21.9-6.7-33.4-6.7H0v2.7h34.6 C45.8,136.3,56.7,138.5,67,142.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.8,132.5c7.1,3,13.7,6.8,19.7,11.5h4.3c-6.9-5.8-14.6-10.5-23-14c-10.6-4.4-21.9-6.7-33.4-6.7H0v2.7h40.4 C51.6,126,62.5,128.2,72.8,132.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurf);
export default __webpack_public_path__ + "static/media/surf.e2a747d366a56cbba0bdb3a5f3b10804.svg";
export { ForwardRef as ReactComponent };